<template>
        <div>
            <div class="text-right p-10 text-xl font-semibold">
                <span v-if="user">{{user.name}} |</span>
                <span class="hover:text-aux" @click="logOut"> Cerrar sesión</span>
            </div>
            <div class="absolute" style="top: 50%; transform: translateY(-50%)translateX(-50%); left: 50%;">
            <div>
                <img class="w-auto h-64" src="images/logotipo-la-tienda-de-valentina.jpg">
            </div>
                    <div class="flex items-center justify-center" v-if="user">
                        <span v-for="(userDashboard, idx) in user.dashboards" :key="idx">
                            <template v-for="(dashboard, index) in dashboards">
                                <router-link v-if="dashboard.name === userDashboard && dashboard.external == false" :key="index" :to="{name: dashboard.name}" class="bg-box-30 hover:bg-box hover:text-white cursor-pointer px-5 py-2 rounded mx-px">
                                    {{dashboard.alias}}
                                </router-link>
                                <a :href="dashboard.url" v-if="dashboard.name === userDashboard && dashboard.external == true" :key="index" class="bg-box-30 hover:bg-box hover:text-white cursor-pointer px-5 py-2 rounded mx-px">
                                    {{dashboard.alias}}
                                </a>
                            </template>
                        </span>
                    </div>
            </div> 
        </div>

</template>

<script>
import { state, actions } from '@/store';
import All from '@/api/components/All.vue';
import Auth from '@/api/models/Auth';


    export default {
        name: 'Home',
        components:{
            All
        },
        computed: {

            showMenu(){
                return state.showMenu
            }

        },

        methods: {
            async setUserData() {

            },
            
            async logOut(){
                await Auth.logout();
                actions.setToken(null);
                this.$router.push({name: 'login'});
            }
        },

        watch:{
            showMenu(n,o){

            }

        },

        created(){
            this.user = state.user
        },

        data(){
            return {
                user: null,
                dashboards: [
                    {name: 'retail', alias: 'Móvil', external: false},
                    {name: 'stock', alias: 'Stock', external: false}, 
                    {name: 'sales', alias: 'Ventas', external: false}, 
                    {name: 'backoffice', alias: 'Backoffice', external: true, url: process.env.VUE_APP_API_URL+'/admin'}
                ],
            }
        }
    }
</script>
